import { render } from "./Contact.vue?vue&type=template&id=b312f6fa"
const script = {}

import exportComponent from "D:\\job\\guobao\\guobao-ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__